






















import {Component, Prop, Vue} from 'vue-property-decorator';
import { RelatedOrder } from '@/model/RelatedOrder';
import humanReadableQuantity from '@/filters/QuantityFormatter';
import formatDate from '@/filters/DateFormatter';
import { OrderedProductStatuses } from '@/model/OrderedProductStatus';
import ProcessedQuantityDialog from "@/components/dialog-box/ProcessedQuantityDialog.vue";
import { Quantity } from '@/model/Quantity';

@Component({
    components : {ProcessedQuantityDialog},
    filters: {humanReadableQuantity, formatDate}
})
export default class RelatedOrderPanel extends Vue {

    @Prop({default: {}}) order: RelatedOrder;
    @Prop({default: false}) canHandleSupports: boolean;

    public isDialogOpen: boolean = false;

    public updateRelatedOrderStatus(processedQuantity: Quantity) {
        this.$emit('updateRelatedOrderStatus', this.order.orderId, processedQuantity);
    }

    public openQuantityProcessedBox(){
        this.isDialogOpen = true;
    }

    public setDialogClose(){
        this.isDialogOpen = false;
    }

    public confirmDialog(processedQuantity: Quantity){
        this.updateRelatedOrderStatus(processedQuantity);
        this.setDialogClose();
    }

    get isProcessed(): boolean {
        return this.order.status === OrderedProductStatuses.PREPARED;
    }
}
